import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DroppService} from '../../../../services/integrations/dropp.service';
import {DroppLocationModel} from '../../../../models/integrations/dropp/dropp-location.model';
import {CountryModel} from '../../../../models/localization-and-pricing/country.model';
import {UserModel} from '../../../../models/authentication/user.model';

@Component({
  selector: 'app-shipping-info',
  templateUrl: './shipping-info.component.html',
  styleUrls: ['./shipping-info.component.css']
})
export class ShippingInfoComponent implements OnInit {

  /**
   * White color for the title
   */
  inputTitleColor = '#FFFFFF';

  /**
   * #FFFFFF white color we can have
   */
  inputBgColor = '#FFFFFF';

  zip: number;

  droppLocationsForZip: DroppLocationModel[] = [];
  droppLocationsAroundZip: DroppLocationModel[] = [];

  homeDeliveries: DroppLocationModel[] = [];
  flytjandi: DroppLocationModel;

  @Input() shippingInfo = new ShippingInfoModel();

  @Output() onLocationSelected = new EventEmitter();

  constructor(private droppSv: DroppService) { }

  ngOnInit() {

    this.droppSv.fetchData();

    const user = UserModel.getCurrent();
    if (user) {
      this.shippingInfo.firstName = UserModel.getCurrent().firstName;
      this.shippingInfo.lastName = UserModel.getCurrent().lastName;
      this.shippingInfo.country = UserModel.getCurrent().country;
    }

  }

  setLocation(loc: DroppLocationModel, selection: boolean) {

    if (selection) {

      if (loc) {
        this.shippingInfo.location = loc;
        this.shippingInfo.shippingPrice = loc.price;
      } else {
        this.shippingInfo.location = null;
        this.shippingInfo.shippingPrice = 0;
      }


    } else {

      this.shippingInfo.location = null;
      this.shippingInfo.shippingPrice = 0;

    }

    this.emitEvent();


  }

  isLocationSelected(loc: DroppLocationModel) {

    if (this.shippingInfo.location) {

      return loc.id === this.shippingInfo.location.id && loc.dayDelivery === this.shippingInfo.location.dayDelivery;
    }

    return false;

  }

  onZipChanged(newZip: number) {

    this.zip = newZip;
    this.shippingInfo.zip = newZip;
    // We need to reset the selected location as we ahve
    // selected a new zip code to ship to
    this.shippingInfo.location = null;
    this.setLocation(null, false);

    if (this.zip && this.zip !== 0) {

      this.droppLocationsForZip = this.droppSv.findDroppLocationsForZip(this.zip);
      this.droppLocationsAroundZip = this.droppSv.findDroppLocationsAroundZip(this.zip, this.droppLocationsForZip);
      this.homeDeliveries = this.droppSv.findHomeDeliveryOptions(this.zip);
      this.flytjandi = this.droppSv.findFlytjandiDeliveryOptions(this.zip);

    }

  }

  emitEvent() {

    if (this.onLocationSelected) {
      this.onLocationSelected.emit(this.shippingInfo);
    }

  }

}

export class ShippingInfoModel {

  firstName: string;
  lastName: string;

  phone: string;
  company: string;

  address: string;
  city: string;
  state: string;

  zip: number;

  country = 'IS';

  shippingPrice = 0;

  location: DroppLocationModel;

}
